/*
 * @Author: klcxkjhsm huangshimin@klcxkj.com
 * @Date: 2024-07-18 10:24:47
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2024-08-12 15:38:49
 * @FilePath: \app-client-h5\src\pages\coupon\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import { queryShareCodeDetail, activityJoin } from './service'
import { Toast, Button, ImageViewer, Mask, NoticeBar } from 'antd-mobile'
import './index.scss';
import { GetRequest } from "../../utils/util";
import { QuestionCircleFill, } from 'antd-mobile-icons'
class coupon extends Component {
    constructor(props) {
        super(props)
        this.state = {
            shareBg: require('./images/shareBg.png'),
            close: require('./images/close.png'),
            correct: require('./images/code-bg.png'),
            arrow: require('../../assets/arrow.png'),
            failure: require('./images/failure.png'),
            activety: 565,
            shareCode: null,
            projectName: null,
            activtityData: {
                givenList: [],
                relationActivity: {
                    givenList: [],
                }
            },
            avtivityHeight: 0,
            unfold: true,
            visible: false,
            activityType: null,
            participateVisible: false,
            activeStuts: false,
            imgVisible: false,
            userJoinRule: null,
        }

    }
    componentDidMount() {
        let data = GetRequest().data;
        data = data.replace(/([a-zA-Z0-9]+):/g, '"$1":')
        data = data.replace(/:([a-zA-Z0-9]+)/g, ':"$1"')
        data = JSON.parse(data)
        window.localStorage.setItem('token', data.token);
        document.title = '活动详情'
        this.setState({
            projectId: data.projectId,
            accountId: data.accountId,
            token: data.token,
            activityId: data.activityId,
            userId: data.userId,
            shareCode: data.shareCode
        }, () => {
            const { accountId, projectId, token, activityId, userId, } = this.state;
            this.getActivityDetail(userId, accountId, projectId, token, activityId,);
        })
    }
    getActivityDetail(userId, accountId, projectId, token, activityId,) {
        let params = {
            userId,
            accountId,
            loginCode: token,
            activityId,
            projectId,

        }
        queryShareCodeDetail(params).then(res => {
            if (res.errorCode === 0) {
                let data = res.data.activityType === 4 ? res.data.relationActivity : res.data
                data.activityValue = this.switchStatus(data.activityStatus).value
                data.activityClass = this.switchStatus(data.activityStatus).className
                data.givenList.forEach(element => {
                    element.givenTemplateList.forEach(item => {
                        item.template.tiemList = item.template.timeDesc.split('~')
                    })
                });
                if (data.givenList) {
                    data.givenList.activityValue = this.switchStatus(data.givenList.activityStatus).value
                    let unfold = data.givenList.length && data.givenList[0].givenTemplateList.length > 3 ? true : false
                    let avtivityHeight = data.givenList.length && data.givenList[0].givenTemplateList.length * 1.66
                    this.setState({
                        activtityData: data,
                        unfold,
                        avtivityHeight,
                        projectName: data.projectName
                    })
                }
                this.setState({
                    activityType: res.data.activityType,
                    userJoinRule: res.data.userJoinRule
                })
            } else {
                Toast.show({
                    icon: 'fail',
                    content: res.errorMessage,
                    duration: 1100,
                })
            }
        })
    }
    handleExplain() {
        this.setState({
            visible: true
        })
    }
    setVisible() {
        this.setState({
            visible: false
        })
    }
    switchStatus(key) {
        let value = ""
        let className = ""
        switch (key) {
            case 0:
                value = "未开始"
                className = "status_coupon_disable"
                break;
            case 1:
                value = "进行中"
                className = "status_coupon_default"

                break;
            case 2:
                value = "已结束"
                className = "status_coupon_error"
                break;
            case 3:
                value = "已失效"
                className = "status_coupon_error"
                break;
            default:
                break;
        }
        return { value, className }
    }
    changeDown() {
        this.setState({
            unfold: !this.state.unfold
        })
    }
    handleParticipate() {
        this.setState({
            participateVisible: true
        })
    }
    cancel() {
        this.setState({
            participateVisible: false
        })
    }
    submit() {
        let { accountId, token, activityId, projectId, userId, shareCode, telPhone } = this.state
        let params = {
            accountId,
            loginCode: token,
            activityId,
            projectId,
            userId,
            shareCode,
            telPhone,
        }
        if (!telPhone) {
            Toast.show({
                icon: 'fail',
                content: '请输入手机号',
                duration: 1100,
            })
            return
        }
        activityJoin(params).then(res => {
            if (res.errorCode === 0) {
                this.setState({
                    activeStuts: true,
                    participateVisible: false,
                })
                let tips = this.state.activtityData.activityType === 2 ? '充值吧！' : '消费吧！'
                Toast.show({
                    icon: 'success',
                    content: "报名成功！快去趣智校园" + tips,
                    duration: 1100,
                })
            } else {
                Toast.show({
                    icon: 'fail',
                    content: res.errorMessage,
                    duration: 1100,
                })
            }
        })
    }
    async copyTextToClipboard() {
        let text = this.state.shareCode
        try {
            await navigator.clipboard.writeText(text);
            Toast.show({
                icon: '',
                content: "邀请码已复制到剪切板",
                duration: 1100,
            })
            console.log('Text copied to clipboard');
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }
    handleSubmit(index) {
        let type = this.state.activtityData.activityStatus
        if (type === 1) {
            if (index === 1) {
                this.handleLinkRegister()
            } else {
                this.handleParticipate()
            }

        } else {
            Toast.show({
                icon: '',
                content: "活动" + this.state.activtityData.activityValue,
                duration: 1100,
            })
            return false
        }
    }
    handleLinkRegister() {

        const { projectName, accountId, projectId, token, activityId, userId, shareCode, activityType } = this.state;
        let data = {
            userId,
            accountId,
            token,
            activityId,
            projectId,
            projectName
        }
        if (activityType === 4) {
            data.shareCode = shareCode
        }
        window.location.href = origin + '/couponRegister?data=' + JSON.stringify(data)
    }
    telPhoneInput(e) {
        this.setState({
            telPhone: e.target.value
        })
    }
    setImgVisible(imgVisible) {
        this.setState({
            imgVisible
        })
    }
    render() {
        const { userJoinRule, failure, imgVisible, activityType, participateVisible, activeStuts, activtityData, shareCode, visible, correct, close } = this.state
        var rulesAry = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
        return (
            <div className='wrap'>
                <ImageViewer
                    key={activtityData.imageUrl}
                    classNames={{
                        mask: 'customize-mask',
                        body: 'customize-body',
                    }}
                    image={activtityData.imageUrl}
                    visible={imgVisible}
                    onClose={() => {
                        this.setImgVisible(false)
                    }}
                />
                <div className='advertiseBg' style={{ backgroundImage: 'url(' + activtityData.imageUrl + ')' }}>
                    <div className='advertiseBg-box'></div>
                    {
                        activityType !== 1 && activityType !== 4 ?
                            <NoticeBar style={{ "--text-color": "#EA4542", "--background-color": "#FEF0F0", "--font-size": "13px", "--height": "32px", "--icon-font-size": "none" }} content='请下载趣智校园APP，或微信/支付宝搜索趣智校园小程序，登录后可参与活动' color='alert' />
                            : null
                    }
                    {
                        activtityData.imageUrl ?
                            <Button className='preview-btn' style={{ top: activityType !== 1 && activityType !== 4 ? '47px' : '16px' }} onClick={() => this.setImgVisible(true)}>点击查看全图</Button>
                            : null
                    }
                </div>
                <div className='shareWrap'>
                    <div className='shareBox mgb16'>
                        <div className='mgb16'>
                            <span className='tit'>项目名称：</span>
                            <span className='txt'>{activtityData.projectName}</span>
                        </div>
                        <div className='mgb16'>
                            <span className='tit'>活动名称：</span>
                            <span className='txt'>{activtityData.activityName}</span>
                            <span className={'status_coupon ' + activtityData.activityClass} >{activtityData.activityValue}</span>
                        </div>
                        <div>
                            <span className='tit'>活动时间：</span>
                            <span className='txt'>{activtityData.effectTime}</span>
                        </div>
                    </div>
                    <div className='shareBox mgb16'>
                        <div className='tit'>活动说明：</div>
                        <pre className='txt'>{activtityData.remark}</pre>
                    </div>
                    <div className="shareBox mgb16" style={{ display: activtityData.activityType !== 1 ? "block" : "none" }}>
                        <div className='tit'>用户参与次数规则：</div>
                        <div className='txt'>{activtityData.userJoinRule}</div>
                    </div>
                    <div className='shareBox mgb16'>
                        <div className='mgb16'>
                            <span className='tit'>{(activityType !== 1 && activtityData.activityType !== 1) ? '送券' : '活动'}规则：</span>
                            <span className='txt'>{activtityData.givenRule}</span>
                        </div>
                        {
                            activtityData && activtityData.givenList.map((item, index) => {
                                return <>
                                    <div>
                                        <div className='rule-item' style={{ display: activityType !== 1 && activtityData.activityType !== 1 ? "flex" : "none" }}>
                                            <div className='rule-label'>规则
                                                {
                                                    activtityData.givenList.length > 1 ?
                                                        <span>{rulesAry[index]}</span>
                                                        : null
                                                }
                                            </div>
                                            <div className='rule-value'>{item.givenDesc}</div>
                                        </div>
                                        {
                                            item && item.givenTemplateList.map(res => {
                                                return (

                                                    <div className="couponItem mgb16" key={res.status} style={{ filter: res.template.status !== 1 ? "" : " grayscale(100%)" }} >
                                                        {res.template.status !== 1 ? null :
                                                            <div className="failure">
                                                                <img src={failure} alt="" />
                                                            </div>
                                                        }
                                                        <div className="couponItem_t">
                                                            <span className='couponItem_num'>{res.count}张</span>
                                                            <div className="left_money">
                                                                <div className="l_top" >
                                                                    <span>{res.template.reduceAmountDesc}</span>
                                                                    <span className="unit">{res.template.reduceAmountUnit}</span>
                                                                </div>
                                                                <div className="l_bottom">{res.template.conditionAmountDesc}</div>
                                                            </div>
                                                            <div className="right_text">
                                                                <div className="r_top">{res.template.typeName}</div>
                                                                <div className="r_middle">
                                                                    <div className='r_tit'>使用时间：</div>
                                                                    <div className='r_txt'>
                                                                        {res.template.tiemList[0]}
                                                                        <br />
                                                                        {res.template.tiemList[1]}
                                                                    </div>
                                                                </div>
                                                                <div className="r_bottom"><span>适用：</span><span>{res.template.rangeDesc}</span></div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                )
                                            })
                                        }

                                    </div>
                                </>
                            })
                        }
                    </div>
                </div>
                <div className='activity-footer' style={{ display: (activityType === 4 && !activeStuts) || activityType === 1 ? "block" : "none" }}>
                    <div className='footer-top' style={{ display: activityType === 4 ? "block" : "none" }}>
                        <div className='share-code'>{activtityData.activityType === 1 ? "注册" : "活动"}邀请码<QuestionCircleFill onClick={() => this.handleExplain()} style={{ marginLeft: '0.16rem' }} fontSize={16} />： <span>{shareCode}</span><span onClick={() => this.copyTextToClipboard()} style={{ color: "#5ABDFC", marginLeft: '8px' }}>复制</span></div>
                    </div>
                    {
                        activityType === 1 || activtityData.activityType === 1 ?
                            <Button block shape='rounded' color='primary' onClick={() => this.handleSubmit(1)} className='footer-submit'>去注册</Button> :

                            <Button onClick={() => this.handleSubmit(2)} block shape='rounded' style={{ display: activtityData.activityType === 1 && activityType !== 4 ? "none" : "block" }} color='primary' className='footer-submit'>去报名</Button>
                    }
                </div>

                <Mask visible={participateVisible} >
                    <div className='participate-modal'>
                        <div className='header-title'>报名</div>
                        <div className='body-content'>
                            <input onBlur={(e) => this.telPhoneInput(e)} type="text" name="telephone" placeholder='请输入趣智账号(手机号)' id="" />
                        </div>
                        <div className='footer-button'>
                            <Button onClick={() => this.cancel()} block shape='rounded' color='primary' className='btn cancel-btn'>取消</Button>
                            <Button onClick={() => this.submit()} block shape='rounded' color='primary' className='btn submit-btn'>提交</Button>
                        </div>
                    </div>
                </Mask>
                <Mask visible={visible} >
                    <div className='coupon-modal'>
                        <div className='header-img'>
                            <img className='img-logo' src={correct} alt="" />
                        </div>
                        <div className='header-title'>{activtityData.activityType === 1 ? "注册" : "活动"}邀请码</div>
                        {
                            activtityData.activityType === 1 ?
                                <div className='body-content'>
                                    通过此邀请码进行注册的用户，将成为邀请人的助力用户！
                                </div> :
                                <div className='body-content'>
                                    <p>可通过活动邀请码参与活动。</p>
                                    <div> 参与方式：打开趣智校园APP，或在微信/支付宝搜索“趣智校园”小程序，登录应用，在我的-活动中心-点击'+邀请码参与活动'，输入邀请码，即可报名参与！</div>
                                </div>
                        }

                        <img className='img-close' src={close} alt="" onClick={() => this.setVisible()} />
                    </div>
                </Mask>
            </div>
        );
    }
}

export default coupon;
